





















import { Component, Vue } from "vue-property-decorator";
import API from "../store/api";
import { IRelease } from "@/interfaces/orchestrator.interface";
import { DataTableHeader } from "vuetify";
import { WithRoute } from "@/router";
import { PUBLIC_PATH } from "@/config"

interface IReleaseTableHeader extends DataTableHeader {
  value: keyof IRelease;
}

@Component({
  components: {}
})
export default class OrchestratorReleasesView extends Vue implements WithRoute {
  loading: boolean = true;
  releases: IRelease[] = [];

  headers: IReleaseTableHeader[] = [
    { text: "Process-Key", value: "ProcessKey" },
    {
      text: "Name",
      value: "Name"
    }
  ];

  async mounted() {
    this.loading = true;
    const relResponse = await API.getOrchestratorReleases();
    if (relResponse != null) {
      this.releases = relResponse.value;
    }
    this.loading = false;
  }

  onClickRow(release: IRelease) {
    this.$router.push({ path: PUBLIC_PATH + `/release/${release.Id}/formbuilder` });
  }
}
